<template>
  <SeeRoutDetail :recordId="recordId" :reportShowType="reportShowType" :tenant="tenant"/>
</template>
<script>
import SeeRoutDetail from './details/seeRoutDetail.vue';

export default {
  data() {
    return {
      recordId: null,
      reportShowType: 1,
      tenant: ''
    };
  },
  components: {
    SeeRoutDetail
  },
  mounted() {
    this.tenant = this.$route.query.tenant;
    this.recordId = this.$route.query.taskRecordId;
    if (this.$route.query.reportShowType) {
      this.reportShowType = Number(this.$route.query.reportShowType);
    }
  },
};
</script>
